import React, { FC } from 'react';
import { FuelDialog } from '@frete.com/fuel-station-react';
import { FuelTypography } from '@frete.com/fuel-react';
import { UnofficalTruckerPhoneAlertProps } from './types';
import { PORTAL_NAME } from '@/constants';

export const UnofficalTruckerPhoneAlert: FC<UnofficalTruckerPhoneAlertProps> = ({ isOpen, onRefuse, onConfirm }) => (
  <FuelDialog.Root isOpen={isOpen} onClose={onRefuse} width="md" portalName={PORTAL_NAME} showCloseButton>
    <FuelDialog.Header>
      <FuelTypography size="heading-sm" weight="bold" color="neutral-strong">
        Atenção! Esse telefone não é o número oficial do motorista
      </FuelTypography>
    </FuelDialog.Header>
    <FuelDialog.Body>
      <FuelTypography tag="p" variant="regular" color="neutral-default" size="body-md">
        Confirme os dados antes de seguir com a GR,
        <FuelTypography displayInline variant="bold" color="inherit" size="body-md">
          isso pode ser golpe!
        </FuelTypography>
      </FuelTypography>
    </FuelDialog.Body>
    <FuelDialog.Footer>
      <FuelDialog.Action variant="tertiary" onClick={onConfirm}>
        Continuar mesmo assim
      </FuelDialog.Action>
      <FuelDialog.Action variant="primary" onClick={onRefuse}>
        Cancelar
      </FuelDialog.Action>
    </FuelDialog.Footer>
  </FuelDialog.Root>
);
